import React from 'react';
import { Section } from './ui/Section';
export function SocialProof() {
  const stats = [{
    value: '+500',
    label: 'personas liberadas'
  }, {
    value: '4',
    label: 'Tomos listos'
  }, {
    value: '4',
    label: 'Bonos incluidos'
  }, {
    value: '4.9/5',
    label: 'calificación ⭐'
  }];
  return <Section className="py-8 md:py-12" data-id="element-189">
      <div className="bg-brand-card border border-neutral-800 rounded-2xl p-8" data-id="element-190">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-191">
          {stats.map((stat, i) => <div key={i} className="space-y-2" data-id="element-192">
              <div className="text-3xl md:text-4xl font-bold text-brand-accent" data-id="element-193">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-neutral-400 font-medium uppercase tracking-wider" data-id="element-194">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}